import { App } from './views'
import { routesConfig } from './routesConfig'
import { AppIcon } from './components';

const displayName = "Feedback"
const appName = displayName.toLowerCase().replace(' ', '_')

export {displayName, appName}